module.exports = __webpack_public_path__ + "img/static-map.240653d9.png";